import(/* webpackMode: "eager" */ "/var/www/gruppo-piccrillo-front/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gruppo-piccrillo-front/src/app/providersSession.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gruppo-piccrillo-front/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/gruppo-piccrillo-front/src/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/gruppo-piccrillo-front/src/redux/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/gruppo-piccrillo-front/styles/globals.css");
